import React from 'react';
import { SelectInput } from 'react-admin';

/**
 * The classes academic content can be filed against, as a fixed list.
 *
 * Deliberately NOT the `class-group` resource. That table serves quizzes and
 * batches and carries the junior classes too; this library is board/entrance
 * material and only ever covers 10th, 11th, 12th and Droppers.
 *
 * The ids are what `academic_content.class_group_id` stores and must stay in
 * step with Academic_content_model::$CLASS_GROUPS on the API side, which is
 * the copy the web and mobile apps read. Changing a class here means changing
 * it there.
 */
export const ACADEMIC_CLASS_GROUPS = [
  { id: 10, name: '10th' },
  { id: 11, name: '11th' },
  { id: 12, name: '12th' },
  { id: 13, name: 'Dropper' }
];

/**
 * A drop-in replacement for `<ReferenceInput source="class_group_id"
 * reference="class-group">`, serving the fixed list above. No fetch, so the
 * dropdown is populated on first paint.
 */
export const AcademicClassGroupInput = (props: any) => (
  <SelectInput label="Class" choices={ACADEMIC_CLASS_GROUPS} {...props} />
);
